import { CommonData } from "../datastructures/gamestate/gameData";

export function onOptionButtonDown(activeGameData: CommonData) {
    activeGameData.gameOption.setClicked();
    // console.log('CLICK')
}

export function closeOptionWindow(activeGameData: CommonData) {
   
    // console.log(activeGameData.gameOption)
    let isClosed = activeGameData.gameOption.getIsClosed();
    


    if (isClosed == false) {
        activeGameData.gameOption.setOptionAlpha(0);//parentContainer.alpha = 0;
        activeGameData.gameBar.setMobileUIHidden(false);//hideUnhide
        activeGameData.gameOption.setIsClosed(isClosed);
        activeGameData.gameOption.setClicked();//close the gameoptwindow
        activeGameData.gameOption.setActivePage("goal");//makes  default page to 0 and also disable buttons
        for (var i = 0; i < activeGameData.gameOption.getTotalPages(); i++) {
            activeGameData.gameOption.setPageAlpha(i, 0);//pagesContainer[i].alpha = 0;
        }

        activeGameData.gameOption.setInteractivity(false);
    }


}